// extracted by mini-css-extract-plugin
export default {"wrapper":"MissingQuestionsModal_wrapper__psJtp","content":"MissingQuestionsModal_content__bbIuh","likeAnimation":"MissingQuestionsModal_likeAnimation__ovi3X"};